import React, { Component } from 'react'
import { Button, Popconfirm, InputNumber } from 'antd'
import { DebounceInput } from 'react-debounce-input'

const ButtonGroup = Button.Group

class ContractPaymentSchedule extends Component {
  renderItem = (paymentSchedule, index) => {
    const {
      movePaymentScheduleUp,
      movePaymentScheduleDown,
      disableMoveItemDown,
      disableMoveItemUp,
      handleDeletePaymentSchedule,
      handlePaymentScheduleChange
    } = this.props

    if (paymentSchedule) {
      return (
        <div className="row padding10" key={index}>
          <div className="col-md-3">
            <InputNumber
              min={0}
              max={100}
              step={0.1}
              precision={2}
              formatter={value => `${value}%`}
              parser={value => value.replace('%', '')}
              value={paymentSchedule.percentage ? paymentSchedule.percentage * 100 : ''}
              onChange={value => handlePaymentScheduleChange(value, 'percentage', index)}
            />
          </div>
          <div className="col-md-6">
            <DebounceInput
              className="ant-input"
              minLength={0}
              debounceTimeout={500}
              value={paymentSchedule.description ? paymentSchedule.description : ''}
              onChange={e => handlePaymentScheduleChange(e.target.value, 'description', index)}
              name="description"
            />
          </div>
          <div className="col-md-3 text-right">
            <ButtonGroup>
              <Button
                disabled={disableMoveItemUp}
                icon="caret-up"
                onClick={() => movePaymentScheduleUp(index)}
              />
              <Button
                disabled={disableMoveItemDown}
                icon="caret-down"
                onClick={() => movePaymentScheduleDown(index)}
              />
              <Popconfirm
                title="Are you sure you want to delete this line?"
                onConfirm={() => handleDeletePaymentSchedule(index)}
                onCancel={this.cancelDelete}
                okText="Yes"
                cancelText="No"
              >
                <Button type="danger" icon="delete" />
              </Popconfirm>
            </ButtonGroup>
          </div>
        </div>
      )
    }
  }

  render() {
    const { paymentSchedule, index } = this.props

    if (paymentSchedule) {
      return this.renderItem(paymentSchedule, index)
    } else {
      return <ol>loading...</ol>
    }
  }
}

export default ContractPaymentSchedule



// WEBPACK FOOTER //
// ./src/pages/lead/components/contracts/ContractPaymentSchedule.js